package ar.corzo.health_tracker

import ar.corzo.firebase.logOut
import ar.corzo.firebase.logUser
import ar.corzo.firebase.npm.User
import ar.corzo.firebase.npm.auth
import ar.corzo.firebase.npm.initApp
import ar.corzo.firebase.npm.onAuthStateChanged
import ar.corzo.firebase.npm.signOut
import ar.corzo.health_tracker.connections.authClient
import ar.corzo.health_tracker.connections.getAccountByID
import ar.corzo.health_tracker.connections.serverBase
import ar.corzo.health_tracker.types.Account
import ar.corzo.health_tracker.types.state.State
import ar.corzo.health_tracker.types.state.State.Companion.toState
import ar.corzo.health_tracker.types.state.StateData
import ar.corzo.health_tracker.types.state.StateData.Companion.toStateData
import ar.corzo.health_tracker.utils.dateFormat
import ar.corzo.health_tracker.utils.rememberScope
import ar.corzo.health_tracker.utils.getString
import ar.corzo.health_tracker.utils.parseJsonToNative
import ar.corzo.health_tracker.utils.toJsonObject
import emotion.react.css
import io.ktor.client.HttpClient
import io.ktor.client.engine.js.Js
import io.ktor.client.request.delete
import io.ktor.client.request.get
import io.ktor.client.statement.bodyAsText
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.datetime.format
import react.ChildrenBuilder
import react.FC
import react.dom.html.ReactHTML
import react.dom.html.ReactHTML.b
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.dialog
import react.dom.html.ReactHTML.form
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.hr
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.section
import react.dom.html.ReactHTML.span
import react.useEffect
import react.useRef
import react.useState
import web.cssom.Color
import web.cssom.Display
import web.cssom.Gap
import web.cssom.dvh
import web.cssom.px
import web.html.ButtonType
import web.html.HTMLDialogElement
import web.html.InputType
import kotlin.time.Duration.Companion.seconds
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

fun useAuthUser(): StateData<User>{
    val (user,setUser) = useState<StateData<User>>(StateData.Loading)
    useEffect(emptyList<Any>()){
        initApp()
        onAuthStateChanged(auth()){
            setUser(it.toStateData())
        }
    }
    return user
}
fun useUserId() = useAuthUser().data?.uid
fun useMyAccount(): Account?{
    val id = useUserId()
    return useUser(id)
}
fun useUser(id: String?): Account?{
    val (user,setUser) = useState<Account?>(null)
    useEffect(id){
        setUser(if(id!=null) getAccountByID(id) else null)
    }
    return user
}
fun ChildrenBuilder.DataLabel(title: String, data: Any?){
    section{
        css{
            display = Display.flex
            gap = 10.px
        }

        p{
            +title
        }
        b{
            +(data?.toString()?:"-")
        }
    }
}
val Login = FC {
    val scope = rememberScope()
    val (state,setState) = useState<State?>(null)
    val (email,setEmail) = useState("")
    val (password, setPassword) = useState("")

    h1{
        +"Iniciar sesión"
    }
    form{
        onSubmit = {
            it.preventDefault()
            setState(State.Loading)
            scope.launch {
                setState(logUser(email, password).toState())
                delay(1.seconds)
                setState(null)
            }
        }
        input{
            value = email
            onChange = {
                setEmail(it.currentTarget.value)
            }
            placeholder = "Email"
            type = InputType.email
        }
        input{
            value = password
            onChange = {
                setPassword(it.currentTarget.value)
            }
            placeholder = "Contraseña"
            type = InputType.password
        }
        button{
            type = ButtonType.submit
            disabled = state != null

            +"Entrar"
        }
    }
}
val App = FC {
    val scope = rememberScope()
    val myUser = useAuthUser()
    val myAccount = useMyAccount()
    val (deleteState, setDeleteState) = useState<StateData<String>?>(null)
    val deleteUserDialogRef = useRef<HTMLDialogElement>()
    fun setDeleteUserDialog(open: Boolean){
        if(open)
            deleteUserDialogRef.current?.showModal()
        else
            deleteUserDialogRef.current?.close()
    }

    h1{
        +"Bienvenido a PJ Trainer"
    }
    hr()
    when(myUser){
        is StateData.Success -> {
            section{
                css{
                    padding = 20.px
                    backgroundColor = Color("#f5f5f5")
                    minHeight = 100.dvh
                }

                h2{
                    +"Mi perfil"
                }
                if(myAccount!=null){
                    DataLabel("Nombre", myAccount.name)
                    DataLabel("Peso (Kg)", myAccount.weight)
                    DataLabel("Fecha de nacimiento", myAccount.birth?.format(dateFormat))
                }

                button{
                    onClick = {setDeleteUserDialog(true)}
                    +"Eliminar cuenta"
                }
            }
            dialog{
                onClose = {setDeleteUserDialog(false)}
                ref = deleteUserDialogRef

                h1{
                    +"¿Seguro que quieres eliminar tu cuenta?"
                }
                button{
                    onClick = {_->
                        setDeleteState(StateData.Loading)
                        scope.launch {
                            val data = try {
                                val req = authClient.get("$serverBase/users/myAccount")
                                req.bodyAsText().toJsonObject()?.parseJsonToNative()
                            }catch (e: Throwable){
                                console.error(e)
                                null
                            }
                            val state = data?.getString("state")
                            val message = data?.getString("message")
                            val stateData = if(state == "success") StateData.Success(message.toString()) else StateData.Error(message)
                            setDeleteState(stateData)
                            delay(1.seconds)

                            setDeleteState(null)
                            if(stateData is StateData.Success) logOut()
                        }
                    }
                    disabled = deleteState != null
                    css{
                        padding = 10.px
                        border = 0.px
                        backgroundColor = when(deleteState){
                            StateData.Loading -> Color("yellow")
                            is StateData.Success -> Color("green")
                            is StateData.Error -> Color("red")
                            null -> undefined
                        }
                    }

                    when(deleteState){
                        StateData.Loading -> +"LOADING"
                        is StateData.Success -> +"Usuario Eliminado"
                        is StateData.Error -> +"Error al borrar usuario"
                        null -> +"ELIMINAR"
                    }
                }
            }
        }
        is StateData.Error -> Login()
        StateData.Loading-> +"CARGANDO info de usuario..."
    }
}
